import { Colors } from "@/enums/Colors";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { LazoChatConversationShell } from "@/models/ai-chat/LazoChatConversation";
import { ConversationType } from "@/types/ConversationType";
import { Person } from "@mui/icons-material";
import { Box, SxProps, Typography, styled } from "@mui/material";
import UserAvatar from "../lazo-ai-chat-components/Avatar";

type Props = {
  conversation: LazoChatConversationShell;
};

export function ChatAvatar(props: Props) {
  if (!props.conversation) return <></>;

  return (
    <>
      {props.conversation.conversationType === ConversationType.PRIVATE ? (
        <UserAvatar
          sx={UserAvatarSx}
          user={{ firstName: props.conversation.title?.split(" ")[0], lastName: props.conversation.title?.split(" ")[1] } as User}
        />
      ) : (
        <Avatar
          sx={{ position: "relative", backgroundColor: Colors.BUTTON_SECONDARY_PURPLE, border: `1px solid ${Colors.DARKER_DARKER_GRAY}` }}
        >
          <Person sx={{ fontSize: "2rem" }} />
          <MembersCountContainer>
            <Typography fontSize={"0.625rem"} fontWeight={"500"}>
              {props.conversation.membersCount}
            </Typography>
          </MembersCountContainer>
        </Avatar>
      )}
    </>
  );
}

const UserAvatarSx: SxProps = {
  borderRadius: "0.5rem",
  backgroundColor: Colors.BUTTON_SECONDARY_PURPLE,
  backgroundImage: "none",
  border: `1px solid ${Colors.DARKER_DARKER_GRAY}`,
  color: Colors.ELEGANT_BLACK,
  fontSize: "1.125rem",
};

const Avatar = styled(Box)(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "8px",
  border: Colors.LIGHT_GRAY_8A8E93,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const MembersCountContainer = styled(Box)(() => ({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "0.25rem",
  height: "1.25rem",
  width: "1.25rem",
  backgroundColor: "#fff",
  border: `1px solid ${Colors.DARKER_DARKER_GRAY}`,
  top: 22,
  left: 22,
}));
